module.exports = __webpack_public_path__ + "static/bradesco-bg-ae71cb21e5957f1083c209499c54b02d.png";